import { templates } from '../../../constants/common';

import EgTemplate from './eg';
import VrboTemplate from './vrbo';
import AEMTemplate from './aem';
import AemOkcTemplate from './aemOkc';
import MvpTemplate from './mvp';
import UFOTemplate from './ufo';

export const getTemplate = (templateId, relativePath, isFrboFlow) => {
    switch (templateId) {
    case templates.UFO:
        return UFOTemplate;
    case templates.MVP:
        return MvpTemplate;
    case templates.EG:
        return EgTemplate;
    case templates.AEM_OKC:
        return AemOkcTemplate;
    case templates.AEM:
        if (isFrboFlow) {
            return AEMTemplate;
        }
        switch (relativePath) {
        case '':
        case '/':
        case '/classification':
        case '/classification/':
            return AEMTemplate;
        default:
            return MvpTemplate;
        }
    case templates.VRBO:
    default:
        return VrboTemplate;
    }
};

export default {
    getTemplate
};
